import * as register from './endpoints/register.js'
import * as login from './endpoints/login.js'
import * as codes from './endpoints/codes.js'
import * as toas from './endpoints/toas.js'
import * as logout from './endpoints/logout.js'
import * as translation from './endpoints/translation.js'
import * as payloads from './payloads.js'

// Initialize backend api object
export default {
  register: register,
  login: login,
  codes: codes,
  toas: toas,
  logout: logout,
  translation: translation,
  payloads: payloads
}
